import { CONFIG_PAGES, HTTP_STATUSES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { useDepartment } from "@mibuildweb/hooks";
import { CONFIG_PATHS } from "../../../../routes/config/constants";
import { DepartmentConfigData } from "../ConfigDepartments.types";

export const useDepartmentDetailsViewModel = () => {
  const { navigate } = useRouter();
  const { createDepartment } = useDepartment();

  const handleCreateDepartment = async (data: DepartmentConfigData) => {
    const response = await createDepartment(data);
    if (response.status === HTTP_STATUSES.OK) {
      navigate(CONFIG_PATHS[CONFIG_PAGES.DEPARTMENTS]);
    }
  };

  return {
    handleCreateDepartment,
  };
};
